import styled from 'styled-components'
import { StyledPrefixedInput } from 'components/Input'
import { sc } from 'utils'

const InputLabel = styled.div<{ hideErrorOnFocus?: boolean }>`
  --errorMessageHeight: 20px;

  display: flex;
  flex-direction: column;
  color: var(--gray);
  font: var(--400-12);

  > span:nth-child(1) {
    order: 1;
    margin-bottom: 5px;
  }

  > span:nth-child(2) {
    order: 3;
    color: var(--red);
    text-align: left;
    font: var(--400-11);
    height: var(--errorMessageHeight);
    transition: all 0.2s;

    ::selection {
      background-color: var(--red_0-2);
    }

    :empty {
      height: 0;
    }

    :not(:empty) + input:not(:focus),
    :not(:empty) + ${StyledPrefixedInput} input:not(:focus) {
      outline-color: var(--red);
    }
  }

  ${StyledPrefixedInput},
  > input, > select, >div {
    order: 2;
  }

  ${sc('hideErrorOnFocus', ':focus-within > span:nth-child(2) { height: 0; opacity: 0; }')}
`

InputLabel.defaultProps = {
  hideErrorOnFocus: true
}

export default InputLabel
